import AnswerAlternative from 'src/components/filmquiz/AnswerAlternative';
import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import { type MovieQuestion } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

//#region [Props]
type QuestionProps = {
	doCorrectAnswer: () => void;
	doWrongAnwer: () => void;
	qNum: number;
	question: MovieQuestion;
	isAnswered: boolean;
};
//#endregion

//#region [Component]
export default function Question({ qNum, doCorrectAnswer, doWrongAnwer, question, isAnswered }: QuestionProps) {
    let questionText1: string | undefined;
	let questionText2: string | undefined;
	let actors = "skuespillere: ";
	let index = question.question!.indexOf(actors);
	if (index > 0) {
		questionText1 = question.question!.substring(0, index + actors.length);
		questionText2 = question.question!.substring(index + actors.length, question.question!.length);
	}
	else {
		questionText1 = question.question!;
	}
	return <>
		<SQuestion>
			<SQuestionLine>{qNum}. {questionText1}</SQuestionLine>
			{(questionText2?.length ?? 0) > 0 && <SQuestionLine>{questionText2}</SQuestionLine>}
			{question.sanityImageWideUrl && <SWideImage alt={questionText1} imageUrl={question.sanityImageWideUrl} width={700} unoptimized/>}
			{question.sanityImagePosterUrl && <SPosterImage alt={questionText1} imageUrl={question.sanityImagePosterUrl} width={200} unoptimized isPosterAspect/>}
		</SQuestion>
        {!isAnswered &&
            <SAnswerAlternatives>
                {question.answerAlternatives?.map((alt, idx) => <AnswerAlternative isAnswered={isAnswered} key={idx} answerAlternative={alt!} doCorrectAnswer={doCorrectAnswer} doWrongAnswer={doWrongAnwer} />)}
            </SAnswerAlternatives>
        }

	</>;
}
//#endregion

//#region [Styles]
const SQuestion = styled.div`
	padding-top: 20px;
	padding-bottom: 20px;

	line-height: 24px;
	font-weight: bold;
	letter-spacing: 0.4px;
`;

const SQuestionLine = styled.div`
	display: block;
	margin-bottom: 20px;
	padding-left: 10px;
	padding-right: 10px;

	@media (min-width: 550px) {
        /*@media  (orientation: landscape) {*/
        font-size: 30px;
    }
`;

const SAnswerAlternatives = styled.div`
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 10px;

	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 5px;
`;

const SWideImage = styled(CmsImageForUrl)`
	margin: 0 auto;
	@media (min-width: 550px) {
		max-width: 700px;
		border-radius: 10px;

	}
`;

const SPosterImage = styled(CmsImageForUrl)`
	margin: 0 auto;
	max-width: 200px;
`;
//#endregion